"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2422 17.3422c-.8264-1.2699-1.1125-2.9441-.923-4.6186.2346-2.0739 1.2054-4.2877 2.993-6.0754 3.5856-3.5857 8.9241-3.6472 12.6862-3.6472h1v1c0 3.7637-.0769 9.1164-3.647 12.6867-1.7808 1.7808-3.9944 2.751-6.0687 2.9875-1.6754.191-3.354-.0918-4.6262-.9188l-2.2422 2.2423L3 19.5846l2.2422-2.2424zm3.4843-9.2798c2.6658-2.666 6.6222-3.0163 10.2668-3.0566-.0423 3.646-.4037 7.6151-3.0562 10.2677-1.4536 1.4537-3.2455 2.2281-4.881 2.4146-1.1599.1322-2.1735-.0343-2.9324-.399l1.7462-1.7464h4.3783v-2h-2.3785l1.8328-1.8328h3.4205v-2h-1.4207l2.128-2.1282-1.4142-1.4141L14.29 8.2938V6.8764h-2v3.4175l-1.833 1.8332V9.7509h-2v4.3763l-1.748 1.748c-.3656-.7584-.5334-1.7699-.4025-2.9268.1846-1.6323.9583-3.4243 2.42-4.886z"
  })];
};

exports.default = _default;